import { NIKE_URL } from "@/constants/url";
import { Lang } from "@/data/translation";
import { z } from "zod";

export interface Top20GraphParams {
  investor: string;
  symbol: string;
  lang: Lang;
}

const top20GraphSchema = z.object({
  data: z.array(
    z
      .object({
        // 日期，如 2020-09-30
        date: z.string(),
        // 收盤價，如 139.529（139.53）
        closePrice: z.number(),
        // 交易量加權推估成本，如 138.22（138.22）
        costPrice: z.number(),
      })
      .partial()
  ),
  message: z.string(),
});

export type Top20GraphData = z.infer<typeof top20GraphSchema>["data"][number];

export const getInvestorTop20Graph = async ({
  investor,
  symbol,
  lang,
}: Top20GraphParams): Promise<Top20GraphData[]> => {
  const endpoint = `/13f/${investor}/cost-estimation-graph/${symbol}`;
  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "GET",
    headers: { "Accept-Language": lang },
  });

  if (!res.ok) throw new Error(`API failed (${endpoint})`);
  return top20GraphSchema.parse(await res.json()).data;
};
